import {intlShape, loginContainer, SubmitButton, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {FormattedMessage, defineMessages, injectIntl} from 'react-intl';

import stylesButton from './SaveDeleteButtons.less';

const I18N = defineMessages({
  RESET: {
    id: 'autoLayout.button.reset',
    defaultMessage: 'Reset',
    description: 'title text for auto layout reset button',
  },
});

const ScreenResetButton = ({intl, isDisabled, onReset}) => (
  <SubmitButton
    className={classNames(
      stylesButton.dlSaveDeleteButtonsButton,
      stylesButton.dlButtonTextLight,
      'float-start'
    )}
    dataName={'resetScreenButton'}
    isPrimary={false}
    onClick={onReset}
    disabled={isDisabled}
    title={utils.TranslateUtils.translate(I18N.RESET, intl)}
  >
    <span className={classNames(stylesButton.dlButtonTextLight)}>
      <i
        className={classNames(
          stylesButton.dlButtonIcon,
          'fas fa-undo-alt fa-fw'
        )}
      />
      <span className={stylesButton.dlBoldText}>
        <FormattedMessage {...I18N.RESET} />
      </span>
    </span>
  </SubmitButton>
);

ScreenResetButton.displayName = 'ScreenResetButton';

ScreenResetButton.propTypes = {
  onReset: PropTypes.func,
  intl: intlShape.isRequired,
  isDisabled: PropTypes.bool,
};

ScreenResetButton.defaultProps = {
  onReset: undefined,
  isDisabled: false,
};

export default injectIntl(ScreenResetButton);
